/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material"
import { ChangeEvent, Key } from "react"
import { FieldValues, Path, useController } from "react-hook-form"
import { CustomUIFormComponetProp } from "./interfaceCustomComponent"


export default function CustomFormRadioGroup<TFieldValues extends FieldValues>({
    formContext,
    // attributeInputCallback,
    name,
    options,
    valueType,
    returnObject,
    row,
    required,
    control,
    ...rest
}: CustomUIFormComponetProp<TFieldValues>) {

  

    let { field: {value,onChange }, fieldState: { error } } = useController({
        name: name as Path<TFieldValues>,
       rules: required ? { required: 'This field is required' } : undefined,
        control: control
    })

    var str2bool = (value:any) => {
        if (value && typeof value === "string") {
             if (value.toLowerCase() === "true") return true;
             if (value.toLowerCase() === "false") return false;
        }
        return value;
     }

    const customOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        let radioValue = (event.target as HTMLInputElement).value
        // if(valueType==='boolean'){
        //     radioValue = str2bool(radioValue);           
        // }
        onChange(radioValue)
        if (typeof rest.onChange === 'function') {
            rest.onChange(radioValue)
        }
    }

    const getOptions = ():{value:any,label:string}[] => {
        if (options) {
            return options;
        } else {
            return [{value:'true',label:"Yes"},{value:'false',label:"No"}]
        }

    }

      const isChecked = (element:{value:any,label:string}) =>{
        if(value!==undefined && value!==null  && value===element.value){
            return true;
        }
        return false;
      }

    return (
        <FormControl  id={name+'_formControl'} error={!!error} >
            {/* <FormLabel id={attributeInputCallback.getName()+'_formLabel'} required={attributeInputCallback.isRequired()} error={!!error}> {attributeInputCallback.getPrompt()}</FormLabel> */}
            
            <RadioGroup id={name+'_radioGroup'}
                //defaultValue={attributeInputCallback.getInputValue()}
                name={name as Path<TFieldValues>}
                onChange={customOnChange}
                row={row}

            >{
                    getOptions().map(element => {
                        return <FormControlLabel  
                       // id={attributeInputCallback.getName()} 
                        value={element.value} 
                        control={<Radio checked={isChecked(element)} />}
                        label={element.label} 
                        key={element.value}  />
                    })
                }

              
                

            </RadioGroup>
           
            {!!error && <FormHelperText>{error?.message}</FormHelperText>}
        </FormControl>

    )
}